import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatLegacySelectionListChange as MatSelectionListChange } from '@angular/material/legacy-list';
import { UntilDestroy } from '@ngneat/until-destroy';
import { getTrackByFn } from '@y42/angular/util';
import { GoJsSearchDialogParams, GoJsSearchNode } from './gojs-search-node.model';

@UntilDestroy()
@Component({
  selector: 'y42-gojs-search-node',
  templateUrl: './gojs-search-node.component.html',
  styleUrls: ['./gojs-search-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoJsSearchNodeComponent {
  constructor(
    public dialogRef: MatDialogRef<GoJsSearchNodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GoJsSearchDialogParams,
  ) {}

  readonly NotFoundIcon = 'assets/images/miscellaneous/info.svg';
  readonly NotFoundPlaceholder = 'Cannot find the table.';

  searchKey = '';
  searchNodes: GoJsSearchNode[] = this.data.nodes;

  trackByKey = getTrackByFn<GoJsSearchNode>('key');

  onSelectionChanged(selection: MatSelectionListChange) {
    this.data.selectedNodeId = selection.options.map((o) => o.value).pop();
    this.dialogRef.close(this.data);
  }
}
